<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar dados fiscais / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <tabMenuClient :id="client.id" :type="client.type"></tabMenuClient>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <form @submit="update">
                                    <div class="row mt-1">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">CNPJ*</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: xx.xxx.xxx/xxxx-xx"
                                                    v-model="client.document_formatted" disabled>
                                                <div class="input-group-append">
                                                    <button class="btn btn-success" type="button" id="button-addon2"
                                                        :disabled="client.type == 'pf'" @click="searchCNPJ()"><i
                                                            class="fa fa-search"></i>Buscar
                                                        dados fiscais pelo CNPJ </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">Regime Tributário*</label>
                                            <div class="input-group mb-3">
                                                <select class="form-control" v-model="client_fiscal.tax_regime">
                                                    <option value="" disabled selected>Selecione uma opção</option>
                                                    <option value="Simples Nacional">Simples Nacional</option>
                                                    <option value="Lucro Presumido">Lucro Presumido</option>
                                                    <option value="Lucro Real">Lucro Real</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">CNAE Fiscal</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_fiscal.cnae_fiscal">
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Descrição CNAE</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_fiscal.cnae_fiscal_description">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Anexo Fiscal CNAE</label>
                                            <div class="input-group mb-3">
                                                <multiselect v-model="client_fiscal.attachment_fiscal"
                                                    :options="attachment_fiscal_options"
                                                    placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'"
                                                    :deselect-label="'Clique para remover'">
                                                    <template #noResult>
                                                        Nenhum tipo anexo encontrado.
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">CNAE Secundário Fiscal</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_fiscal.cnae_secondary_fiscal">
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Descrição CNAE Secundário</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_fiscal.cnae_secondary_fiscal_description">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Anexo Fiscal CNAE Secundário</label>
                                            <div class="input-group mb-3">
                                                <multiselect v-model="client_fiscal.attachment_secondary_fiscal"
                                                    :options="attachment_fiscal_options"
                                                    placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'"
                                                    :deselect-label="'Clique para remover'">
                                                    <template #noResult>
                                                        Nenhum tipo anexo encontrado.
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Registro Estadual</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_fiscal.state_registration">
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Registro Municipal</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_fiscal.municipal_registration">
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Fator R</label>
                                            <div class="input-group mb-3">
                                                <multiselect v-model="factor_r_multiselect" :options="factor_r_options"
                                                    placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'"
                                                    :custom-label="factorRWithLang"
                                                    :deselect-label="'Clique para remover'"
                                                    @select="handleSelectFactorR">
                                                    <template #noResult>
                                                        Opção não encontrada.
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Data situação cadastral</label>
                                            <div class="input-group mb-3">
                                                <input type="date" class="form-control"
                                                    v-model="client_fiscal.date_situation_cadastral">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Natureza jurídica</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_fiscal.legal_nature">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Situação cadastral</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_fiscal.situation_cadastral">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Tamanho empresa</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="client_fiscal.company_size">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-4">
                                        <div class="col-lg-12 col-xs-12 col-sm-12">
                                            <label for="">Observações</label>
                                            <editorText @update-text="updateObservation"
                                                :modelValue="client_fiscal.observation"
                                                placeholderSend="Sem observações" ref="myChild"></editorText>
                                        </div>
                                    </div>
                                    <br> <br>
                                    <div class="row mt-3">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Atualizar</button>
                                            <router-link to="/client" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i>
                                                Cancelar</router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { getCNPJ, loadBank } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';
import tabMenuClient from './tab-menu-client.vue';
import Multiselect from 'vue-multiselect'


export default {
    directives: { mask },
    components: { Loading, editorText, tabMenuClient, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {},
            banks: {},
            client_id: '',
            attachment_fiscal_options: ['Anexo I', 'Anexo II', 'Anexo III', 'Anexo IV','Anexo V'],
            factor_r_options: [{ type: '1', value: 'Sim' }, { type: '0', value: 'Não' }],
            factor_r_multiselect: '',
            client_fiscal: {
                id: '',
                tax_regime: '',
                state_registration: '',
                municipal_registration: '',
                cnae_fiscal: '',
                cnae_fiscal_description: '',
                attachment_fiscal: '',
                cnae_secondary_fiscal: '',
                cnae_secondary_fiscal_description: '',
                attachment_secondary_fiscal: '',
                factor_r: '',
                date_situation_cadastral: '',
                legal_nature: '',
                situation_cadastral: '',
                company_size: '',
                bank: '',
                agency: '',
                account: '',
                type_account: '',
                observation: ''
            },
            enable_error_list: false,
            errors: [],

        }
    },

    computed: {
        isDisabled: function () {
            return this.client_fiscal.tax_regime != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.client_id = id;
        this.getBank();
        this.getFiscalClient();

    },
    methods: {
        onCancel() { },
        setCapitalize(text) {
            return capitalize(text);
        },
        handleSelectFactorR(option) {
            this.client_fiscal.factor_r = option.type;
        },
        factorRWithLang({ value }) {
            return value;
        },
        getBank() {
            this.isLoading = true;
            loadBank().then((response) => {
                this.banks = response;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },
        searchCNPJ() {
            this.isLoading = true;
            if (this.client.document.length > 0) {
                let cnpj = this.client.document.replace(/\D/g, '');
                getCNPJ(cnpj).then((response) => {
                    this.client_fiscal.cnae_fiscal = response.cnae_fiscal + '';
                    this.client_fiscal.cnae_fiscal_description = capitalize(response.cnae_fiscal_descricao);
                    this.client_fiscal.date_situation_cadastral = response.data_situacao_cadastral;
                    this.client_fiscal.legal_nature = capitalize(response.natureza_juridica);
                    this.client_fiscal.situation_cadastral = capitalize(response.descricao_situacao_cadastral);
                    this.client_fiscal.company_size = capitalize(response.porte);
                    //Analisar cnae secundário. Se houver, preencher com o primeiro da lista
                    if (response.cnaes_secundarios.length > 0) {
                        const first_cnae_secondary = response.cnaes_secundarios[0];
                        this.client_fiscal.cnae_secondary_fiscal = first_cnae_secondary.codigo+'';
                        this.client_fiscal.cnae_secondary_fiscal_description = capitalize(first_cnae_secondary.descricao);
                    }
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            }
        },
        updateObservation(observation) {
            this.client_fiscal.observation = observation;
        },
        getFiscalClient() {
            api.get('/client/' + this.client_id + '/fiscal')
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    if (response.data.fiscal_client.length != 0) {
                        this.client_fiscal = response.data.fiscal_client;
                        this.$refs.myChild.updateTextEditor(this.client_fiscal.observation);
                        if (this.client_fiscal.factor_r == '1') {
                            this.factor_r_multiselect = { type: '1', value: 'Sim' };
                        } else {
                            this.factor_r_multiselect = { type: '0', value: 'Não' };
                        }

                       
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/client/' + this.client.id + '/fiscal', this.client_fiscal)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Dados fiscais do cliente atualizado com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>